import { store } from '../../../../../../resources/frontend/js/store/index';
import { leadIsSent } from '@form/utils/send-lead';
import dataLayerPush from '../../../../mixins/utils/data-layer-push';

export const partialElmoCheck = data => {
    const currentStep = store.state.form.attributes.step;
    const amountOfSteps = store.state.form.attributes.amountOfSteps;

    if (currentStep < amountOfSteps) {
        dataLayerPush(`Form step ${currentStep + 1}`);

        store.commit('form/setAttribute', { key: 'step', value: currentStep + 1 });
        store.commit('form/setAttribute', { key: 'loading', value: false });
        store.commit('page/increasePixelStep', { label: 'Form' });
    } else {
        dataLayerPush(`Form submit`);

        leadIsSent(data.response.id, true, data.sms_verification_sent);
    }
};
